import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EnodeService } from 'src/app/services/enode/enode.service';
import { ChargePolicy, EnodeVehicle } from 'src/app/services/enode/enode.types';

@Component({
  selector: 'app-setup',
  templateUrl: './setup.component.html',
  styleUrls: ['./setup.component.scss']
})
export class SetupComponent {
  @Input() vehicle: EnodeVehicle;
  @Output() emitSetupDone = new EventEmitter<boolean>();

  currentStep = 0;
  totalSteps = 3;

  locationName: string;

  smartChargePolicy: ChargePolicy;
  selectedTime: string;
  smartChargePolicyErrorMessage: string;

  constructor(private _enodeService: EnodeService) {
    this.selectedTime = '07:00';
    this.smartChargePolicy = {
      isEnabled: true,
      deadline: this.selectedTime,
      minimumChargeLimit: 0
    };
    this.smartChargePolicyErrorMessage = '';
  }

  continue() {
    if (this.currentStep === this.totalSteps) {
      this.currentStep = this.totalSteps;
    } else {
      // Smart Charge Policy
      if (this.currentStep === this.totalSteps) {
        this.smartChargePolicy.deadline = this.selectedTime;
        this._enodeService
          .updateSmartChargePolicy(this.vehicle.id, this.smartChargePolicy)
          .subscribe({
            next: (res) => {
              this.smartChargePolicyErrorMessage = '';
              this.currentStep++;
            },
            error: (err) => {
              this.smartChargePolicyErrorMessage =
                'Noe gikk galt... Vennligst prøv igjen.';
            }
          });
      } else {
        this.currentStep++;
      }
    }
  }
  back() {
    if (this.currentStep === 0) {
      this.currentStep = 0;
    } else {
      this.currentStep--;
    }
  }

  finish() {
    this.emitSetupDone.emit(true);
  }

  getProgress() {
    return this.currentStep === 0 ? 0 : this.currentStep / this.totalSteps;
  }

  setSelectedTime(time: string) {
    this.selectedTime = time;
  }

  setLocationName(name: string) {
    this.locationName = name;
  }
}
